import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import type { StarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useFreePromotionStatus } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { NOTIFICATION_TYPES } from '../../../constants';

// eslint-disable-next-line complexity
function isEligibleForFreePromotion(petition: StarterDashboardV2PageData['petition']): boolean {
	// If petition is closed, unpublished, or a victory, do not show
	if (petition.status !== 'PUBLISHED') return false;

	// If petition is hidden, do not show tip
	if (!petition.discoverable) return false;

	// If the petition's promotions are not fulfillable, do not show
	if (!petition.promotionSettings?.fulfillmentEligible || !petition.country.promotionCountrySettings?.fulfillmentActive)
		return false;

	// if petition has not reached the 5 signature milestone, do not show
	if (!petition.petitionUpdatesConnection.nodes[0] || petition.petitionUpdatesConnection.nodes[0]?.title !== '5')
		return false;

	// If there has already been a free sample promotion, do not show
	const freePromotion = petition.freePromotions ?? [];
	if (freePromotion.length > 0) return false;
	return true;
}

type UseFreePromotionReturn = { type: (typeof NOTIFICATION_TYPES)['promotion'] } | undefined;
export function useFreePromotion(): UseFreePromotionReturn {
	const {
		data: {
			petition,
			featureConfigs: { pacificPromoFreeSample },
		},
	} = useStarterDashboardV2PageData();

	// shows a banner during processing of the free promotion
	const freePromotion = petition.freePromotions?.find(
		(promotion) => promotion.sourceLocation === 'starter_free_promotion',
	);
	useFreePromotionStatus(freePromotion);

	// ALERTS: comment this line
	// check petition properties
	if (!isEligibleForFreePromotion(petition)) return undefined;
	// ALERTS: comment this line
	// If the `pacific_promo_free_sample` fcm is disabled, do not show tip
	if (!pacificPromoFreeSample) return undefined;
	// ALERTS: comment this line
	// If petition is too old, do not show tip alert
	if (new Date(petition.createdAt) < new Date(pacificPromoFreeSample.startDate || 0)) return undefined;
	return { type: NOTIFICATION_TYPES.promotion };
}
